<template lang="pug">
.mt-3
	.card
		.card-header
			span.fa.fa-info-circle.mr-2
			| Información general
		.card-body
			.row
				.col-xs-12.col-sm-12.col-md-4.col-lg-3.col-xl-3
					.form-group
						label Empresa
						.input-group
							.input-group-prepend
								.input-group-text
									span.fa.fa-building
							select.form-control(v-model="contrato.EmpresaID", :class="(campoFallo === 'empresa') ? 'error' : ''")
								option(:value="null") Selecciona una empresa
								option(v-for="empresa in listadoEmpresas", :key="empresa.ID_empresa", :value="empresa.ID_empresa") {{empresa.nombreFiscal}}
				.col-xs-12.col-sm-12.col-md-4.col-lg-3.col-xl-3
					.form-group
						label Agente
						.input-group
							.input-group-prepend
								.input-group-text
									span.fa.fa-user
							input-query(
								v-if="!contrato.AgenteID",
								:input-class="(campoFallo === 'agente') ? 'error form-control' : 'form-control'",
								placeholder="Busca un agente",
								:realtime="true",
								url="mis-contratos/php/api/buscaAgente.php",
								@selected="setAgente($event)"
							)
							input.form-control(v-if="contrato.AgenteID", :disabled="true", :value="contrato.AgenteNombre")
							.input-group-append(v-if="contrato.AgenteID")
								button.btn.btn-danger(@click="quitarAgente()")
									span.fa.fa-trash
				.col-xs-12.col-sm-12.col-md-4.col-lg-3.col-xl-3
					.form-group
						label Cliente
						.input-group
							.input-group-prepend
								.input-group-text
									span.fa.fa-address-card
							input-query(
								v-if="!contrato.ClienteID",
								:input-class="(campoFallo === 'cliente') ? 'error form-control' : 'form-control'",
								placeholder="Busca un cliente",
								:realtime="true",
								:url="'mis-contratos/php/api/buscaCliente.php?agente=' + contrato.AgenteID",
								@selected="setCliente($event)"
							)
							input.form-control(v-if="contrato.ClienteID", :disabled="true", :value="contrato.ClienteNombre")
							.input-group-append(v-if="contrato.ClienteID")
								button.btn.btn-danger(@click="quitarCliente()")
									span.fa.fa-trash
								button.btn.btn-primary(@click="editaCliente = contrato.ClienteID")
									span.fa.fa-edit
				.col-xs-12.col-sm-12.col-md-4.col-lg-3.col-xl-3
					.form-group
						label Forma de pago
						.input-group
							.input-group-prepend
								.input-group-text
									span.fa.fa-money
							select.form-control(v-model="contrato.FormaDePagoID", :class="(campoFallo === 'formaDePago') ? 'error' : ''")
								option(:value="null") Selecciona
								option(:value="forma.ID_forma_de_pago", v-for="forma in listadoFormasDePago" :key="forma.ID_forma_de_pago") {{forma.nombre}}
		.card-footer
			.div(style="position:relative;display:inline-block;width:200px;")
				.input-group
					.input-group-prepend
						.input-group-text
							| Bruto
					.input-group-append
						button.btn.btn-warning
							b {{importeBruto | currency}}

			.div(style="position:relative;display:inline-block;width:200px;")
				.input-group
					.input-group-prepend
						.input-group-text
							| Neto
					.input-group-append
						button.btn.btn-warning
							b {{importeNeto | currency}}
			.div(style="position:relative;display:inline-block;width:200px;")
				.input-group
					.input-group-prepend
						.input-group-text
							| Total
					.input-group-append
						button.btn.btn-warning
							b {{importeTotal | currency}}
			.div(style="position:relative;display:inline-block;width:200px;")
				.input-group
					.input-group-prepend
						.input-group-text
							| Guardar
					.input-group-append
						button.btn.btn-primary(v-if="contratoValido", @click="guardar")
							span.fa.fa-save
						button.btn.btn-danger(v-else)
							b Faltan datos

	.card.mt-2(v-if="!contratoValido")
		.card-header.bg-danger.text-white
			b ERROR:
			span.ml-2 {{falloForm}}


	.row(v-if="fase1")
		.col-xs-12.col-sm-12.col-md-12.col-lg-12.col-xl-2
			// AHORA LOS DETALLES DE TÍTULO, FECHAS
			.row
				.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-12.mt-2
					.card
						.card-header
							span.fa.fa-edit.mr-2
							| Detalles del contrato
						.card-body
							.form-group
								label Título del contrato
								input.form-control.form-control-sm(v-model="contrato.Titulo", :class="(campoFallo === 'titulo') ? 'error' : ''")

							.form-group
								label Fecha de inicio
								datepicker(
									v-model="contrato.FechaInicio",
									:bootstrap-styling="true"
									:monday-first="true"
									placeholder="Selecciona fecha"
									:disabled-dates="{to: new Date(new Date().getTime() - 86400000)}"
									:class="(campoFallo === 'fechaIni') ? 'error' : ''"
									:input-class="(campoFallo === 'fechaIni') ? 'error' : ''"
									:language="$dateLang"
								)

							.form-group
								label Fecha de fin
								datepicker(
									v-model="contrato.FechaFin"
									:bootstrap-styling="true"
									:monday-first="true"
									placeholder="Selecciona fecha"
									:disabled="!contrato.FechaInicio"
									:disabled-dates="{to: contrato.FechaInicio}"
									:class="(campoFallo === 'fechaFin') ? 'error' : ''"
								)
						.card-body.bg-warning
							.form-group
								label
									b Anunciante asociado
								input-query(
									v-if="!contrato.AnuncianteID"
									:input-class="(campoFallo === 'anunciante') ? 'error form-control' : 'form-control'",
									placeholder="Asigna un anunciante"
									url="gestion-anunciantes/php/api/query.php"
									:realtime="true"
									@selected="asignaAnunciante($event)"
								)
								div.input-group(v-else)
									span.text-primary
										b {{ contrato.AnuncianteNombre }}
									div(style="position:relative;display:block;text-align:center;width:100%;margin-top:10px;")
										button.btn.btn-danger(
											@click="contrato.AnuncianteID = null"
										)
											span Quitar
											span.ml-2
												.fa.fa-trash
				.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-12.mt-2
					// AQUÍ LA PARTIDA, EL EVENTO Y EL INTERMEDIARIO
					.card
						.card-header
							span.fa.fa-edit.mr-2
							| Destinos
						.card-body
							.form-group
								label Tipo de contrato
								select.form-control.form-control-sm(v-model="contrato.TipoID", @change="cambiaTipo", :class="(campoFallo === 'tipo') ? 'error' : ''")
									option(:value="null") Selecciona
									option(v-for="tipo in listadoTipos", :key="tipo.TipoID", :value="tipo.TipoID") {{tipo.Nombre}}
							.form-group
								label Destino
								select.form-control.form-control-sm(v-model="contrato.DestinoID", @change="cambiaDestino", :class="(campoFallo === 'destino') ? 'error' : ''")
									option(:value="null") Selecciona
									option(v-for="destino in listadoDestinos", :key="destino.DestinoID", :value="destino.DestinoID") {{destino.Nombre}}
							.form-group
								label Partida
								select.form-control.form-control-sm(v-model="contrato.PartidaID", @change="cambiaPartida", :class="(campoFallo === 'partida') ? 'error' : ''")
									option(:value="null") Selecciona
									option(v-for="partida in listadoPartidas", :key="partida.PartidaID", :value="partida.PartidaID") {{partida.Nombre}}
							.form-group
								label Evento
								.input-group(v-if="!contrato.EventoID")
									input-query(
										input-class="form-control form-control-sm"
										url="/mis-contratos/php/api/query-eventos.php"
										:realtime="true"
										@selected="seleccionaEvento($event)"
										placeholder="Asocia un evento"
									)
								.input-group(v-else)
									input.form-control.form-control-sm(:value="contrato.EventoNombre", disabled)
									.input-group-append
										button.btn.btn-sm.btn-danger(@click="quitarEvento")
											span.fa.fa-trash
							.form-group(v-if="permisos.contratos_seleccionarIntermediarios")
								label Intermediario
								.input-group.input-group-sm
									.input-group-prepend
										.input-group-text
											span.fa.fa-users
									input-query(v-if="!contrato.IntermediarioID", input-class="form-control form-control-sm", :realtime="true", @selected="setIntermediario($event)", url="/mis-contratos/php/api/buscaIntermediario.php")
									input.form-control.form-control-sm(v-if="contrato.IntermediarioID", :disabled="true", :value="contrato.IntermediarioNombre")
									.input-group-append(v-if="contrato.IntermediarioID")
										button.btn.btn-sm.btn-danger(@click="quitarIntermediario")
											span.fa.fa-trash
									.input-group-append(v-if="!contrato.IntermediarioID")
										button.btn.btn-sm.btn-warning
											span.fa.fa-plus

				.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-12.mt-2
					// AQUÍ LOS DESCUENTOS
					.card
						.card-header
							span.fa.fa-percent.mr-2
							| Descuentos
						.card-body
							.form-group
								label Descuento cadena de valor
								input.form-control.form-control-sm(type="text", v-model.number="contrato.DescuentoCadenaValor", placeholder="Opcional")
							.form-group
								label Descuento comercial
								input.form-control.form-control-sm(type="text", v-model.number="contrato.DescuentoComercial", placeholder="Opcional")

		.col-xs-12.col-sm-12.col-md-12.col-lg-12.col-xl-10.mt-2
			.card.mb-2
				.card-header.bg-dark.text-white
					.row
						.col.text-left
							span.fa.fa-user.mr-2
							| Datos del cliente
						.col.text-right
							button.btn.btn-sm.btn-warning(@click="importarDatosCliente")
								span.fa.fa-download.mr-2
								| Importar de la ficha del cliente
				.card-body
					.row
						.col-xs-12.col-sm-12.col-md-3.col-lg-3.col-xl-3
							.form-group
								label Cliente
								input.form-control.form-control-sm(placeholder="Nombre del cliente" v-model="contrato.cliente.NombreCliente", :class="(campoFallo === 'clienteNombre') ? 'error' : ''")
							.form-group
								label CIF
								input.form-control.form-control-sm(placeholder="X1234567" v-model="contrato.cliente.CIF", :class="(campoFallo === 'clienteCIF') ? 'error' : ''")
						.col-xs-12.col-sm-12.col-md-3.col-lg-3.col-xl-3
							.form-group
								label Representante
								input.form-control.form-control-sm(placeholder="Nombre del representante" v-model="contrato.cliente.Representante", :class="(campoFallo === 'clienteRepresentante') ? 'error' : ''")
							.form-group(v-if="necesitaIBAN")
								label IBAN
								input.form-control.form-control-sm(placeholder="ESXX XXXX XXXX XXXX XXXX" v-model="contrato.cliente.IBAN", :class="(campoFallo === 'clienteIBAN') ? 'error' : ''")
						.col-xs-12.col-sm-12.col-md-3.col-lg-3.col-xl-3
							.form-group
								label Teléfono
								input.form-control.form-control-sm(placeholder="Teléfono de contacto" v-model="contrato.cliente.Telefono")
							.form-group
								label E-mail
								input.form-control.form-control-sm(placeholder="Nombre del cliente" v-model="contrato.cliente.Email")
						.col-xs-12.col-sm-12.col-md-3.col-lg-3.col-xl-3
							.form-group
								label Dirección
								textarea.form-control.form-control-sm(rows="5", placeholder="Dirección postal" v-model="contrato.cliente.Direccion")
			.card
				.card-header
					.row
						.col.text-left
							span.fa.fa-list.mr-2
							| Líneas del contrato
						.col.text-right
							button.btn.btn-primary(@click="nuevaLineaContrato")
								span.fa.fa-plus.mr-2
								| Nueva
				.card-body(v-if="contrato.lineas.length === 0")
					.alert.alert-warning
						| Este contrato no tiene líneas. Pulsa sobre el botón <b>Nueva</b> para crear nuevas
				table.table.m-0(v-else)
					thead
						tr
							th.th-lg.p-1(style="border: 0 !important;") Producto
							th.th-lg.p-1(style="border: 0 !important;") P. unit.
							th.th-lg.p-1(style="border: 0 !important;") Unidades
							th.th-lg.p-1(style="border: 0 !important;") Cant
							th.th-lg.p-1(style="border: 0 !important;") Dto.
							th.th-lg.p-1(style="border: 0 !important;") Imp.
							th.th-lg.p-1(style="border: 0 !important;") Bruto
							th.th-lg.p-1(style="border: 0 !important;") Neto
							th.th-lg.p-1(style="border: 0 !important;") Total
							th.th-lg.p-1(style="border: 0 !important;")
					tbody
						linea-contrato(
							v-for="(linea, index) in contrato.lineas",
							:key="linea.LineaID",
							:idx="index",
							v-model="contrato.lineas[index]",
							@eliminar="quitarLinea(linea)",
							:dto-cad-valor="contrato.DescuentoCadenaValor",
							:dto-comercial="contrato.DescuentoComercial"
						)
				.card-footer(v-if="contrato.lineas.length > 0")
					.row
						.col
							.div(style="position:relative;display:inline-block;width:200px;")
								.input-group
									.input-group-prepend
										button.btn(@click="verCapa = 'facturacion'", :class="(verCapa === 'facturacion') ? 'btn-primary' : ''")
											span.fa.fa-calendar.mr-2
											| Facturación
									.input-group-append
										.input-group-text.bg-danger.text-white(v-if="!facturacionValida")
											span.fa.fa-ban
										.input-group-text.bg-success.text-white(v-else)
											span.fa.fa-check
							.div(style="position:relative;display:inline-block;width:200px;")
								.input-group
									.input-group-prepend
										button.btn(@click="verCapa = 'cobros'", :class="(verCapa === 'cobros') ? 'btn-primary' : ''")
											span.fa.fa-money.mr-2
											| Cobros
									.input-group-append
										.input-group-text.bg-danger.text-white(v-if="!recibosValidos")
											span.fa.fa-ban
										.input-group-text.bg-success.text-white(v-else)
											span.fa.fa-check
							.div(style="position:relative;display:inline-block;width:200px;")
								.input-group
									.input-group-prepend
										button.btn(@click="verCapa = 'comentarios'", :class="(verCapa === 'comentarios') ? 'btn-primary' : ''")
											span.fa.fa-comments.mr-2
											| Comentarios
									.input-group-append
										.input-group-text.bg-danger.text-white(v-if="!contrato.Comentarios")
											span.fa.fa-ban
										.input-group-text.bg-success.text-white(v-else)
											span.fa.fa-check
			cobros.mt-2(
				v-if="verCapa === 'cobros'",
				:contrato.sync="contrato",
				:importe="importeTotal"
				:facturacionValida="facturacionValida"
			)
			facturacion.mt-2(
				v-if="verCapa === 'facturacion'",
				:contrato.sync="contrato",
				:importe="importeTotal",
				:dia-facturacion="diaFacturacion"
				:importeNeto="importeNeto"
			)
			comentarios.mt-2(
				v-if="verCapa === 'comentarios'"
				:contrato.sync="contrato"
			)
	selecciona-datos-cliente(v-if="modalCliente", :ClienteID="modalCliente", @cerrar="modalCliente = null", @asociar="asociarDatoCliente($event)")
	editar-cliente(v-if="editaCliente", :id-cliente="editaCliente", @cerrar="cerrarEditorCliente")
</template>

<script>
import { mapGetters } from 'vuex'
import LineaContrato from './linea-contrato.vue'
import Cobros from './cobros'
import Facturacion from './facturacion'
import Comentarios from './comentarios'
import SeleccionaCliente from './cliente/seleccionaDatos'
import EditarCliente from '../../../../gestion-clientes/vue/components/editor/editor.vue'
import axios from 'axios'
import API from '../../services/api'
export default {
	props: ['contrato'],
	components: {
		'linea-contrato': LineaContrato,
		'facturacion': Facturacion,
		'cobros': Cobros,
		'comentarios': Comentarios,
		'selecciona-datos-cliente': SeleccionaCliente,
		'editar-cliente': EditarCliente
	},
	data () {
		return {
			listadoEmpresas: [],
			listadoTipos: [],
			listadoEventos: [],
			listadoDestinos: [],
			listadoPartidas: [],
			listadoFormasDePago: [],
			idNuevaLinea: 0,
			ibanCliente: null,
			verCapa: null,
			modalCliente: null,
			falloForm: null,
			campoFallo: null,
			editaCliente: null
		}
	},
	watch: {
		'contrato.FormaDePagoID': function (newVal) {
			for (let i = 0; i < this.listadoFormasDePago.length; i++) {
				const f = this.listadoFormasDePago[i]
				if (f.ID_forma_de_pago === newVal) {
					if (f.requiere_iban === 0) {
						this.contrato.cliente.IBAN = null
					}
				}
			}
		}
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario',
			permisos: 'permisos/permisos'
		}),
		fase1 () {
			return (
				this.contrato.EmpresaID &&
				this.contrato.ClienteID
			)
		},
		necesitaIBAN () {
			if (!this.listadoFormasDePago) {
				return false
			}
			if (!this.contrato.FormaDePagoID) {
				return false
			}

			for (let i = 0; i < this.listadoFormasDePago.length; i++) {
				const f = this.listadoFormasDePago[i]
				if (f.ID_forma_de_pago === this.contrato.FormaDePagoID) {
					return (f.requiere_iban === 1)
				}
			}

			return false
		},
		diaFacturacion () {
			if (!this.contrato.TipoID) {
				return -1
			}

			if (this.listadoTipos.length === 0) {
				return -1
			}

			const tipo = this.listadoTipos.filter(t => (t.TipoID === this.contrato.TipoID))[0]
			if (!tipo) {
				return -1
			}

			return tipo.DiaFacturacion
		},
		importeBruto () {
			let importe = 0
			for (let i = 0; i < this.contrato.lineas.length; i++) {
				const l = this.contrato.lineas[i]
				importe += l.ImporteBruto
			}
			return (isNaN(importe)) ? 0 : importe
		},
		importeNeto () {
			let total = 0
			for (let i = 0; i < this.contrato.lineas.length; i++) {
				const l = this.contrato.lineas[i]
				total += l.ImporteNeto
			}
			 // Aplicamos los descuentos
			 if (this.contrato.DescuentoCadenaValor) {
				 total = total - (total * this.contrato.DescuentoCadenaValor / 100)
			 }

			 if (this.contrato.DescuentoComercial) {
				 total = total - (total * this.contrato.DescuentoComercial / 100)
			 }

			return total
		},
		importeTotal () {
			// Calculamos el importe de los impuestos
			let suma = 0
			for (let i = 0; i < this.contrato.lineas.length; i++) {
				const l = this.contrato.lineas[i]
				suma = suma + l.ImporteTotal
			}

			return suma
		},
		importeBrutoContratoImpuestos () {
			// Calculamos el importe de los impuestos
			let suma = this.importeBrutoContrato + 0
			for (let i = 0; i < this.contrato.lineas.length; i++) {
				const l = this.contrato.lineas[i]
				const importeLinea = l.ImporteBruto
				const impuestos = (l.Impuestos) ? l.Impuestos : 0
				const cantidadImpuestos = importeLinea * impuestos / 100
				suma = suma + cantidadImpuestos
			}
			return Math.round(suma * 100) / 100
		},
		recibosValidos () {
			let importe = 0
			for (let i = 0; i < this.contrato.recibos.length; i++) {
				if (this.contrato.recibos[i].FechaVencimiento === null) {
					return false
				}
				if (this.contrato.recibos[i].ImporteTotal === 0 || !this.contrato.recibos[i].ImporteTotal) {
					return false
				}

				importe = importe + this.contrato.recibos[i].ImporteTotal
			}

			if (Math.round(importe * 100) !== Math.round(this.importeTotal * 100)) {
				return false
			}
			return true
		},
		facturacionValida () {
			let importe = 0
			for (let i = 0; i < this.contrato.facturacion.length; i++) {
				if (this.contrato.facturacion[i].FechaFactura === null) {
					return false
				}
				if (this.contrato.facturacion[i].ImporteTotal === 0 || !this.contrato.facturacion[i].ImporteTotal) {
					return false
				}

				importe = importe + parseFloat(this.contrato.facturacion[i].ImporteTotal)
			}

			const importeAComprobar = (this.contrato.FacturacionEnNeto) ? this.importeNeto : this.importeTotal
			if (this.round(importe, 2) !== this.round(importeAComprobar, 2)) {
				return false
			}
			return true
		},
		contratoValido () {
			const contrato = this.contrato

			if (!contrato.EmpresaID) {
				this.falloForm = 'No has seleccionado la empresa desde la que haces el contrato'
				this.campoFallo = 'empresa'
				return false
			}
			this.campoFallo = null

			if (!contrato.AgenteID && !this.permisos.contratos_crearContratosSinAgente) {
				this.falloForm = 'No has definido el agente del contrato'
				this.campoFallo = 'agente'
				return false
			}

			this.campoFallo = null

			if (!contrato.ClienteID) {
				this.falloForm = 'No has definido el cliente'
				this.campoFallo = 'cliente'
				return false
			}

			this.campoFallo = null

			if (!contrato.FormaDePagoID) {
				this.falloForm = 'Selecciona una forma de pago'
				this.campoFallo = 'formaDePago'
				return false
			}

			this.campoFallo = null

			if (!contrato.Titulo) {
				this.falloForm = 'Debes definir el título del contrato'
				this.campoFallo = 'titulo'
				return false
			}

			this.campoFallo = null

			if (!contrato.AnuncianteID) {
				this.falloForm = 'No has asignado un anunciante'
				this.campoFallo = 'anunciante'
				return false
			}

			this.campoFallo = null

			if (!contrato.FechaInicio) {
				this.falloForm = 'Debes definir la fecha de inicio de contrato'
				this.campoFallo = 'fechaIni'
				return false
			}

			this.campoFallo = null

			if (!contrato.FechaFin) {
				this.falloForm = 'Debes definir la fecha de fin de contrato'
				this.campoFallo = 'fechaFin'
				return false
			}

			this.campoFallo = null

			if (!contrato.cliente.NombreCliente) {
				this.falloForm = 'Debes escribir el nombre de la empresa (cliente)'
				this.campoFallo = 'clienteNombre'
				return false
			}

			this.campoFallo = null

			if (!contrato.cliente.Representante) {
				this.falloForm = 'Debes escribir quien es el representante de la empresa del cliente'
				this.campoFallo = 'clienteRepresentante'
				return false
			}

			this.campoFallo = null

			const iban = (typeof contrato.cliente.IBAN === 'string') ? contrato.cliente.IBAN.replace(/\s/ig, '').trim() : null
			if (this.necesitaIBAN && !iban) {
				this.falloForm = 'Debes proporcionar el IBAN para esta forma de pago'
				this.campoFallo = 'clienteIBAN'
				return false
			}

			this.campoFallo = null

			if (!contrato.TipoID) {
				this.falloForm = 'Selecciona el tipo de contrato'
				this.campoFallo = 'tipo'
				return false
			}

			this.campoFallo = null

			if (!contrato.DestinoID) {
				this.falloForm = 'Selecciona el destino del contrato'
				this.campoFallo = 'destino'
				return false
			}

			this.campoFallo = null

			if (!contrato.lineas || contrato.lineas.length === 0) {
				this.falloForm = 'No has añadido ninguna línea en el contrato'
				return false
			}

			if (!this.facturacionValida) {
				this.falloForm = 'La facturación no es válida'
				return false
			}

			if (!this.recibosValidos) {
				this.falloForm = 'Los cobros no son válidos'
				return false
			}

			// Las líneas deben tener impuestos
			for (let i = 0; i < contrato.lineas.length; i++) {
				const l = contrato.lineas[i]
				if (typeof contrato.lineas[i].Impuestos !== 'number') {
					this.falloForm = 'No has definido los impuestos de la línea ' + (i + 1)
					return false
				}

				if (!l.Concepto || typeof l.ImporteUnitario !== 'number' || typeof l.Unidades !== 'number' || typeof l.Cantidad !== 'number') {
					this.falloForm = 'No has definido el concepto de la línea ' + (i + 1)
					return false
				}

				if (!l.Cantidad || l.Cantidad <= 0) {
					this.falloForm = 'La cantidad de la línea ' + (i + 1) + ' debe ser un número superior a 0'
					return false
				}
			}

			return true
		}
	},
	created () {
		axios.get('mis-contratos/php/api/get-listado-empresas.php')
			.then(res => {
				this.listadoEmpresas = res.data
			})
			.catch(this.$responseError)

		axios.get('mis-contratos/php/api/get-tipos-contrato.php')
			.then(res => {
				this.listadoTipos = res.data.tipos
			})
			.catch(this.$responseError)

		axios.get('mis-contratos/php/api/get-destinos.php')
			.then(res => {
				this.listadoDestinos = res.data.destinos
			})
			.catch(this.$responseError)
		API.getFormasDePago()
			.then(res => {
				this.listadoFormasDePago = res.data.formas
			})
			.catch(this.$responseError)
		API.getPartidas()
			.then(res => {
				this.listadoPartidas = res.data
			})
			.catch(this.$responseError)
	},
	methods: {
		importarDatosCliente () {
			this.modalCliente = parseInt(this.contrato.ClienteID)
		},
		asociarDatoCliente (ev) {
			if (!this.necesitaIBAN && ev.campo === 'IBAN') {
				return
			}
			this.contrato.cliente[ev.campo] = ev.dato
		},
		quitarAgente () {
			this.contrato.AgenteID = null
			this.contrato.AgenteNombre = null
		},

		setAgente (e) {
			this.contrato.AgenteID = e.datos.ID
			this.contrato.AgenteNombre = e.datos.nombre + ' ' + e.datos.apellidos
		},

		cerrarEditorCliente () {
			this.editaCliente = null
		},

		quitarCliente () {
			this.contrato.ClienteID = null
			this.contrato.ClienteNombre = null
			this.contrato.cliente.ClienteID = null
		},

		setCliente (e) {
			this.contrato.ClienteID = e.datos.ID
			this.contrato.ClienteNombre = e.datos.cliente
			this.ibanCliente = e.datos.iban

			this.contrato.cliente.ClienteID = parseInt(e.datos.ID)

			// Buscamos la forma de pago del cliente
			this.contrato.FormaDePagoID = parseInt(e.datos.FormaPagoID)

			const necesitaIBAN = this.listadoFormasDePago.reduce((acc, forma) => {
				if (forma.ID_forma_de_pago === e.datos.FormaPagoID) {
					acc = (forma.requiere_iban === 1 && acc === null) ? true : acc
				}
			}, null)

			this.importarDatosCliente()

			if (necesitaIBAN) {
				this.contrato.cliente.IBAN = null
			}
		},

		importarIBAN () {
			if (!this.ibanCliente) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'El cliente seleccionado no tiene un número de IBAN válido'
				})
				return
			}
			this.contrato.IBAN = this.ibanCliente
		},

		asignaAnunciante (ev) {
			this.contrato.AnuncianteID = ev.datos.AnuncianteID
			this.contrato.AnuncianteNombre = ev.datos.AnuncianteNombre
		},

		seleccionaEvento (ev) {
			this.contrato.EventoID = ev.datos.ID_evento
			this.contrato.EventoNombre = ev.datos.titulo
		},

		quitarEvento () {
			this.contrato.EventoID = null
			this.contrato.EventoNombre = null
		},

		quitarIntermediario () {
			this.contrato.IntermediarioID = null
			this.contrato.IntermediarioNombre = null
		},

		setIntermediario (e) {
			this.contrato.IntermediarioID = e.datos.IntermediarioID
			this.contrato.IntermediarioNombre = e.datos.Nombre
		},
		cambiaTipo () {
			let tipo = this.listadoTipos.filter(p => (p.TipoID === this.contrato.TipoID))[0]
			if (!tipo) {
				tipo = {
					DiaFacturacion: -1
				}
			}
			// Ajustamos los días
			for (let i = 0; i < this.contrato.facturacion.length; i++) {
				const f = this.contrato.facturacion[i]
				if (!f.FacturacionID.match(/^[0-9]{1,}$/)) {
					// Ajustamos el día de facturación
					if (tipo.DiaFacturacion > 0) {
						this.contrato.facturacion[i].FechaFactura.setDate(tipo.DiaFacturacion)
					} else {
						this.contrato.facturacion[i].FechaFactura.setDate(1)
						this.contrato.facturacion[i].FechaFactura.setMonth(this.contrato.facturacion[i].FechaFactura.getMonth() + 1)
						this.contrato.facturacion[i].FechaFactura.setDate(this.contrato.facturacion[i].FechaFactura.getDate() + tipo.DiaFacturacion)
					}
				}
			}
			this.$emit('update:contrato', this.contrato)
			this.$forceUpdate()
		},

		cambiaDestino () {
			this.$emit('update:contrato', this.contrato)
			this.$forceUpdate()
		},

		cambiaPartida () {
			this.$emit('update:contrato', this.contrato)
			this.$forceUpdate()
		},

		nuevaLineaContrato () {
			this.contrato.lineas.push({
				LineaID: 'L-' + (++this.idNuevaLinea).toString(),
				ContratoID: null,
				CatalogoID: null,
				ArticuloID: null,
				ArticuloUnitario: 0,
				ImporteUnitario: null,
				Unidades: 1,
				Cantidad: 1,
				Descuento: null,
				Impuestos: 21,
				ImpuestosNombre: 'IVA',
				ImpuestosID: 1,
				ImporteBruto: null,
				ImporteNeto: null,
				ImporteTotal: null,
				ImporteImpuestos: null,
				Tipo: 'Articulo',
				DescuentoCadenaValor: null,
				DescuentoComercial: null
			})

			this.$forceUpdate()
		},

		quitarLinea (linea) {
			for (let i = 0; i < this.contrato.lineas.length; i++) {
				if (this.contrato.lineas[i].LineaID === linea.LineaID) {
					this.contrato.lineas.splice(i, 1)
					return
				}
			}
		},

		guardar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Guardar el contrato',
				mensaje: `¿Quieres guardar este contrato?
				Esto generará una nueva versión del contrato`,
				callback: acepta => {
					if (acepta) {
						API.setContrato(this.contrato)
							.then(res => {
								this.$store.commit('toast/success', {
									titulo: 'Contrato guardado',
									mensaje: 'Se ha guardado el contrato correctamente'
								})
								this.$router.push('/main/contratos/listado/' + res.ContratoID)
							})
							.catch(e => {
								if (e.response) {
									this.$store.commit('alertas/error', {
										titulo: 'Error',
										mensaje: e.response.data.error
									})
								} else {
									console.error(e)
								}
							})
					}
				}
			})
		}
	}
}
</script>


<style scoped>
.error {
	border-color: darkred;
	background-color: #fff0ef;
}
</style>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/contrato/detalles.vue